// Dutch slug → English slug mapping
const serviceSlugMap = {
  'seo-strategie': 'seo-strategy',
  'seo-tekstschrijver': 'seo-copywriting',
  'technische-seo': 'technical-seo',
  'linkbuilding': 'link-building',
  'seo-consultancy': 'seo-consultancy',
  'geo': 'geo',
  'local-seo': 'local-seo',
  'seo-audits': 'seo-audits',
  'ecommerce-seo': 'ecommerce-seo',
  'migratie': 'migration',
  'traffic-recovery-audit': 'traffic-recovery-audit',
  'content-performance-audit': 'content-performance-audit',
  'full-scope-audit': 'full-scope-audit',
};

// English slug → Dutch slug (reverse)
const serviceSlugMapReverse = Object.fromEntries(
  Object.entries(serviceSlugMap).map(([nl, en]) => [en, nl])
);

export function getServiceSlug(nlSlug, language) {
  if (language === 'en') return serviceSlugMap[nlSlug] || nlSlug;
  return nlSlug;
}

export function resolveServiceSlug(urlSlug) {
  // If it's already a Dutch slug (used as internal key), return it
  if (serviceSlugMap[urlSlug]) return urlSlug;
  // If it's an English slug, map back to Dutch key
  if (serviceSlugMapReverse[urlSlug]) return serviceSlugMapReverse[urlSlug];
  return urlSlug;
}

export function getPaths(language) {
  const isEn = language === 'en';
  return {
    home: isEn ? '/en' : '/',
    werkwijze: isEn ? '/en/how-i-work' : '/werkwijze',
    diensten: isEn ? '/en/services' : '/diensten',
    service: (nlSlug) => {
      const slug = isEn ? (serviceSlugMap[nlSlug] || nlSlug) : nlSlug;
      return isEn ? `/en/services/${slug}` : `/diensten/${slug}`;
    },
    pakketten: isEn ? '/en/seo-packages' : '/seo-pakketten',
    consultant: isEn ? '/en/seo-consultant' : '/seo-consultant',
    overMij: isEn ? '/en/about' : '/over-mij',
    contact: isEn ? '/en/contact' : '/contact',
    intake: isEn ? '/en/intake' : '/intake',
    blog: isEn ? '/en/blog' : '/blog',
  };
}
